import React from 'react';

import styles from './index.module.scss';
import ShareYourTwoCentsHeader from './ShareYourTwoCents';
import BusinessSearchPage from './BusinessSearchPage';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';

export default function ShareTwoCentsContent(): React.ReactElement {
  return (
    <>
      <ShareYourTwoCentsHeader />

      <div className={styles.wrapper}>
        <div className={styles.container}>
          <BusinessSearchPage />
        </div>
      </div>

      <JoinOurCommunity />
    </>
  );
}
